import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase';
import './App.css';
import Login from './Login';
import Home from './Home';
import Event from './Event';
import About from './About';
import Footer from './components/Footer';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh', background: '#F4F5F7', display: 'flex',
        alignItems: 'center', justifyContent: 'center'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '60px', marginBottom: '20px' }}>🃏</div>
          <h1 style={{ fontSize: '48px', fontWeight: '900', color: '#2C3E50', margin: 0, fontStyle: 'italic' }}>
            PickFlip
          </h1>
        </div>
      </div>
    );
  }

  // 🚨 수정된 부분: 무조건 로그인을 강제하던 if (!user) 구문을 삭제하고 Routes 안에서 제어합니다.
  return (
  <BrowserRouter>
    <>
      <Routes>
        <Route path="/" element={user ? <Home user={user} /> : <Login />} />
        <Route path="/event/:eventId" element={<Event />} />
        <Route path="/about" element={<About />} />
      </Routes>

      <Footer
        kakaopayLink="https://qr.kakaopay.com/FdBLYiRRE9c401556"
        paypalLink="https://www.paypal.com/paypalme/nuhpulnuhpul"
      />
    </>
  </BrowserRouter>
);
}

export default App;